var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "device-setting-container" }, [
      _c("div", { staticClass: "device-set-preview-option-title-wrapper" }, [
        _c("h3", { staticClass: "device-set-preview-option-title video" }, [
          _vm._v(_vm._s(_vm.$t("common.device.camera"))),
        ]),
        _vm.devices.videoinput.length > 0
          ? _c("span", [
              _vm._v(_vm._s(_vm.$t("common.device.workingNormally"))),
            ])
          : _c("span", [
              _vm._v(_vm._s(_vm.$t("common.device.videoInputDeviceNotFound"))),
            ]),
      ]),
      _vm.devices.videoinput.length > 0
        ? _c(
            "div",
            { staticClass: "device-set-preview-option-select-wrapper" },
            [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedDevice.videoinput.deviceId,
                      expression: "selectedDevice.videoinput.deviceId",
                    },
                  ],
                  staticClass: "form-select",
                  on: {
                    change: [
                      function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.selectedDevice.videoinput,
                          "deviceId",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                      _vm.onChangeVideoDevice,
                    ],
                  },
                },
                _vm._l(_vm.devices.videoinput, function (device) {
                  return _c(
                    "option",
                    {
                      key: device.deviceId,
                      class: {
                        selected:
                          device.deviceId ===
                          _vm.selectedDevice.videoinput.deviceId,
                      },
                      domProps: { value: device.deviceId },
                    },
                    [_vm._v(_vm._s(device.label))]
                  )
                }),
                0
              ),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }